import React from "react";
import { useMutation } from "@tanstack/react-query";
import { submitPut } from "../../../../../../enums/queryFunction/Submit";
import { SnackbarContext } from "../../../../../../contexts/Snackbar";
import { WAREHOUSE_PREFERENCES } from "../../../../../../enums/ApiPaths";

export default function useUpdateWarehousePreferences(clinicId) {
  const { handleSnackbar } = React.useContext(SnackbarContext);

  const mutation = useMutation({
    mutationFn: (data) => submitPut(`${WAREHOUSE_PREFERENCES}${clinicId}`, data),
  });

  async function updatePreferences(priceEntryMode, defaultVat, currency) {
    try {
      const response = await mutation.mutateAsync({ priceEntryMode, defaultVat, currency });
      handleSnackbar("success", "success");
      return response?.data ?? null;
    } catch (error) {
      handleSnackbar(error, "error");
      return null;
    }
  }

  return { updatePreferences, isUpdating: mutation.isPending };
}
